import React, { Component } from "react";
import { MyButton } from "../../Common/Forms/formsMiscItems";
import { cross } from "react-icons-kit/icomoon/cross";
import SvgIcon from "react-icons-kit";
import { languageService } from "../../../Language/language.service";
import TooltipContainer from "../../../libraries/TooltipContainer";
import { LCMethods } from "../AssetConsistMethods";
class ConsistRow extends Component {
  handleEdit = () => {
    const { onEdit, assets } = this.props;
    if (onEdit) {
      onEdit(assets);
    }
  };

  handleDelete = () => {
    const { onDelete, assets } = this.props;
    if (onDelete) {
      onDelete(assets);
    }
  };

  render() {
    const { assets, disableRowActions, consistNumber, allowLocomotiveRemove, onRemoveLocomotive, editIcon, inProgressJP } = this.props;

    // Sort based on assignedConsist.order
    const sortedLocos = [...assets].sort((a, b) => {
      const orderA = Number(a.assignedConsist.order || 0);
      const orderB = Number(b.assignedConsist.order || 0);
      return orderA - orderB;
    });
    let inprogress = LCMethods.getInProgressAssetIds(
      inProgressJP,
      assets.map((a) => a._id),
    );
    return (
      <div>
        {consistNumber && <div style={{ marginBottom: "5px", fontWeight: "bold", fontSize: "13px" }}>Consist: {consistNumber}</div>}

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {/* Locomotive List */}
          <div
            style={{
              overflowX: "auto",
              display: "flex",
              flexGrow: 1,
              flexShrink: 1,
              alignItems: "center",
              paddingBottom: "8px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
              {sortedLocos.map((loco, index) => (
                <React.Fragment key={loco._id}>
                  <div
                    style={{
                      padding: "10px 15px",
                      border: "2px solid #333",
                      borderRadius: "8px",
                      backgroundColor: "#eee",
                      fontWeight: "bold",
                      textAlign: "center",
                      fontSize: "11px",
                      position: "relative",
                      minWidth: "100px",
                      flexShrink: 0,
                    }}
                  >
                    {loco.unitId}
                    {allowLocomotiveRemove && (
                      <div
                        onClick={() => onRemoveLocomotive && onRemoveLocomotive(loco)}
                        style={{ cursor: "pointer", position: "absolute", top: "-10px", right: "-10px" }}
                        title={languageService("Remove Locomotive")}
                      >
                        <SvgIcon icon={cross} size={14} style={{ color: "red" }} />
                      </div>
                    )}
                  </div>
                  {index < sortedLocos.length - 1 && <div style={{ margin: "0 5px", color: "#555", whiteSpace: "nowrap" }}>—</div>}
                </React.Fragment>
              ))}
            </div>
          </div>

          {/* Action Buttons */}
          {!disableRowActions && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "15px",
                alignItems: "center",
                position: "relative",
                marginLeft: "10px",
                flexShrink: 0,
                fontSize: "12px",
              }}
            >
              <div style={{ height: "60px", width: "1px", backgroundColor: "#ccc", position: "absolute", left: "0px" }} />
              {!inprogress.length > 0 ? (
                <div style={{ display: "flex", flexDirection: "row", gap: "15px", width: "175px", marginInlineStart: "20px" }}>
                  <MyButton onClick={this.handleEdit} style={{ minWidth: "80px" }}>
                    Edit
                  </MyButton>
                  <MyButton onClick={this.handleDelete} style={{ minWidth: "80px", margin: 0 }}>
                    Delete
                  </MyButton>
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "175px",
                    marginInlineStart: "20px",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <TooltipContainer tooltipText={languageService("Daily Inspection In Progress")}>
                    <img style={{ width: "35px", color: "yellow" }} src={editIcon} alt={"daily"} />
                  </TooltipContainer>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ConsistRow;



// WEBPACK FOOTER //
// ./src/components/Consist/ConsistList/index.jsx